
webpack.register(
    'components/timeline/animation-queue/animation-queue',
    function() {
        return require('components/timeline/animation-queue/animation-queue');
    },
    false
);
webpack.register(
    'components/timeline/animation-item/animation-item',
    function() {
        return require('components/timeline/animation-item/animation-item');
    },
    false
);
webpack.register(
    'components/timeline/card/card',
    function() {
        return require('components/timeline/card/card');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from=\"components/timeline/animation-queue/animation-queue\"/>\r\n<can-import from=\"components/timeline/animation-item/animation-item\"/>\r\n<can-import from=\"components/timeline/card/card\"/>\r\n\r\n<div class=\"c-timeline-feed c-timeline-feed--{{timelineType}}\">\r\n    <div class=\"s-content\">\r\n        <animation-queue {^queue}=\"animationQueue\" {timeline-type}=\"timelineType\">\r\n            {{#each cards}}\r\n                <animation-item {is-embed}=\"embed\" {queue}=\"animationQueue\" {timeline-type}=\"timelineType\">\r\n                    {{#unless closed}}\r\n                        <div class=\"s-feed-item\">\r\n                            <timeline-card\r\n                                {^closed}=\"closed\"\r\n                                {card}=\"../.\"\r\n                                {(active-card)}=\"../../activeCard\"\r\n                                card-index=\"{{math %index '+' 1}}\"\r\n                                timelineType=\"{{timelineType}}\"\r\n                            />\r\n                        </div>\r\n                    {{/unless}}\r\n                </animation-item>\r\n            {{/each}}\r\n        </animation-queue>\r\n    </div>\r\n</div>\r\n");